import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=d64a8c72"
import script from "./infoList.vue?vue&type=script&lang=js"
export * from "./infoList.vue?vue&type=script&lang=js"
import style0 from "./infoList.vue?vue&type=style&index=0&id=d64a8c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports